module.exports = "https://trybtryb-legacy.web.app/img/bahama-blue.107ea92b.webp";